<div class="application">
    <mat-toolbar color="primary" class="toolbar">
        <img src="../assets/img/mgis/MGIS2.png" alt="MGIS Logo" class="logo" />
        <div class="toolbar-inner">High Limits Disability Insurance Application</div>
    </mat-toolbar>

    <!-- <div class="app-progress">
        <div class=app-progress-inner>Application Progress</div>
        <ngb-progressbar class="mb-3 progress-bar" [showValue]="true" type="primary" [value]="percent" />
    </div> -->

    <div class="app-questionnaire">
        <div class="chat">
            <div class="chat-box">
                <img src="../assets/img/mgis/MgisLogo.png" alt="MGIS Logo" class="chat-image" />
            </div>
        </div>
        <div class="main-chat">
            <div class="text-bubble">
                <div class="typing-effect">
                </div>
            </div>
            <div *ngIf="step==='firstQuestion'" class="response">
                <div class="button-area">
                    <button (click)="gotoStep('login')" class="chat-button" mat-flat-button
                        [disabled]="typing">Yes</button>
                    <button (click)="gotoStep('sponsorToken')" class="chat-button" mat-flat-button
                        [disabled]="typing">No</button>
                </div>
            </div>
            <div *ngIf="step==='sponsorToken'" class="response">
<div class="input-area">
  <mat-form-field>
    <mat-label>Sponsor Token</mat-label>
    <input
      type="sponsorToken"
      class="input chat-input"
      matInput
      [formControl]="sponsorTokenControl"
      (keydown.enter)="startApplication()"
      required
      [errorStateMatcher]="matcher1"
      matTooltip="Please enter the Sponsor Token provided"
    />
    <mat-error *ngIf="sponsorTokenControl.invalid">
      Please enter a valid Sponsor Token
    </mat-error>
  </mat-form-field>
</div>
<div class="button-area">
    <button (click)="gotoStep('firstQuestion')" class="chat-button" mat-flat-button
                        [disabled]="typing">Back</button>
    <button (click)="startApplication()" class="chat-button" mat-flat-button [disabled]="typing">Go</button>
</div>
            </div>
            <div *ngIf="step==='login'" class="response">
                <div class="input-area">
                    <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input type=email class="input" matInput [(ngModel)]="email" class="chat-input"
                            (keydown.enter)="gotoStep('emailSent')" (input)="onNameInput()" required [errorStateMatcher]="matcher1" />
                        <mat-icon matSuffix>mail</mat-icon>
                        <mat-error>Please enter a valid Email</mat-error>
                    </mat-form-field>
                </div>
                <div class="button-area">
                    <button (click)="gotoStep('firstQuestion')" class="chat-button" mat-flat-button
                        [disabled]="typing">Back</button>
                    <button (click)="gotoStep('emailSent')" class="chat-button" mat-flat-button
                        [disabled]="typing">Submit</button>
                </div>
            </div>

            <div *ngIf="step==='previousEnrollment'" class="response">
                <div class="code-area-inner">
                    <button  (click)="rerouteCode('validateCode'); gotoStep('emailSent')" class="chat-button" mat-flat-button  
                        [disabled]="typing">Continue Prior Quote</button>
                    <button (click)="rerouteCode('overrideEnrollment'); gotoStep('overridePrevious')" class="chat-button" mat-flat-button
                        [disabled]="typing">Start a New Quote</button>
                </div>
            </div>
            <div *ngIf="step==='expiredQuote'" class="response">
                <div class="code-area-inner">
                    <button (click)="rerouteCode('overrideEnrollment'); gotoStep('overridePrevious')" class="chat-button" mat-flat-button
                        [disabled]="typing">Continue</button>
                </div>
            </div>
            <div *ngIf="step==='previouslySubmitted'" class="response">
                <div class="button-area">
                    <button (click)="gotoLanding()" class="chat-button" mat-flat-button
                        [disabled]="typing">Start Over</button>
                </div>
            </div>

            <div *ngIf="step==='emailSent'" class="response">
                <div class="code-area" (paste)="onPaste($event)">
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code1 [(ngModel)]="code1Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code1,code1, code2)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code2 [(ngModel)]="code2Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code1, code2, code3)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code3 [(ngModel)]="code3Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code2, code3, code4)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code4 [(ngModel)]="code4Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code3, code4, code5)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code5 [(ngModel)]="code5Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code4, code5, code6)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code6 [(ngModel)]="code6Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code5, code6, code6)" />
                    </mat-form-field>
                </div>
                <div class="code-area-inner">
                    <button (click)="gotoStep('validateCode')" class="chat-button" mat-flat-button [disabled]="typing">Continue</button>
                    <button (click)="gotoStep('noCode')" class="chat-button" mat-flat-button [disabled]="typing">I didn't get a code</button>
                    <button (click)="gotoStep('startOver')" class="chat-button" mat-flat-button>Return to Homepage</button>
                </div>
            </div>

            <div *ngIf="step==='newToken'" class="response">
                <div class="code-area" (paste)="onPaste($event)">
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code1 [(ngModel)]="code1Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code1,code1, code2)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code2 [(ngModel)]="code2Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code1, code2, code3)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code3 [(ngModel)]="code3Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code2, code3, code4)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code4 [(ngModel)]="code4Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code3, code4, code5)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code5 [(ngModel)]="code5Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code4, code5, code6)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code6 [(ngModel)]="code6Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code5, code6, code6)" />
                    </mat-form-field>
                </div>
                <div class="code-area-inner">
                    <button (click)="gotoStep('validateCodeNewToken')" class="chat-button" mat-flat-button
                        [disabled]="typing">Continue</button>
                    <button (click)="gotoStep('noCode')" class="chat-button" mat-flat-button [disabled]="typing">I
                        didn't
                        get a code</button>
                </div>
            </div>

            <div *ngIf="(step==='overridePrevious' || step==='existingUser')" class="response">
                <div class="code-area" (paste)="onPaste($event)">
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code1 [(ngModel)]="code1Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code1,code1, code2)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code2 [(ngModel)]="code2Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code1, code2, code3)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code3 [(ngModel)]="code3Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code2, code3, code4)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code4 [(ngModel)]="code4Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code3, code4, code5)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code5 [(ngModel)]="code5Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code4, code5, code6)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code6 [(ngModel)]="code6Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code5, code6, code6)" />
                    </mat-form-field>
                </div>
                <div class="code-area-inner">
                    <button (click)="overrideEnrollment()" class="chat-button" mat-flat-button
                        [disabled]="typing">Continue</button>
                    <button (click)="gotoStep('noCode')" class="chat-button" mat-flat-button [disabled]="typing">
                       I didn't get a code</button>
                </div>
            </div>

            <div *ngIf="step==='emailNotFound'" class="response">
                <div class="code-area-inner">
                    <button (click)="gotoStep('login')" class="chat-button" mat-flat-button [disabled]="typing">Try a
                        different email address</button>
                    <button (click)="gotoStep('startOver')" class="chat-button" mat-flat-button>Return to Homepage</button>
                </div>
            </div>

            <div *ngIf="step==='noCode'" class="response">
                <div class="code-area" (paste)="onPaste($event)">
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code1 [(ngModel)]="code1Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code1,code1, code2)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code2 [(ngModel)]="code2Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code1, code2, code3)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code3 [(ngModel)]="code3Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code2, code3, code4)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code4 [(ngModel)]="code4Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code3, code4, code5)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code5 [(ngModel)]="code5Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code4, code5, code6)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code6 [(ngModel)]="code6Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code5, code6, code6)" />
                    </mat-form-field>
                </div>
                <div class="code-area-inner">
                    <button (click)="gotoStep(validateCode)" class="chat-button" mat-flat-button
                        [disabled]="typing">Continue</button>
                </div>
                <div class="code-area-inner"><button (click)="gotoStep('sendAnotherCode')" class="chat-button" mat-flat-button
                        [disabled]="typing">Send the code again</button>
                    <button (click)="gotoStep('startOver')" class="chat-button" mat-flat-button>Return to Homepage</button>
                </div>
            </div>

            <div *ngIf="step==='sendAnotherCode'" class="response">
                <div class="code-area" (paste)="onPaste($event)">
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code1 [(ngModel)]="code1Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code1,code1, code2)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code2 [(ngModel)]="code2Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code1, code2, code3)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code3 [(ngModel)]="code3Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code2, code3, code4)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code4 [(ngModel)]="code4Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code3, code4, code5)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code5 [(ngModel)]="code5Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code4, code5, code6)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code6 [(ngModel)]="code6Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code5, code6, code6)" />
                    </mat-form-field>
                </div>
                <div class="code-area-inner">
                    <button (click)="gotoStep(validateCode)" class="chat-button" mat-flat-button
                        [disabled]="typing">Continue</button>
                    <button (click)="gotoStep('sendAnotherCode')" class="chat-button" mat-flat-button
                        [disabled]="typing">Send the code
                        again</button>
                    <button (click)="gotoStep('startOver')" class="chat-button" mat-flat-button>Start over from the
                        Homepage</button>
                </div>
            </div>

            <div *ngIf="step==='invalidCode'" class="response">
                <div class="code-area" (paste)="onPaste($event)">
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code1 [(ngModel)]="code1Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code1,code1, code2)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code2 [(ngModel)]="code2Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code1, code2, code3)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code3 [(ngModel)]="code3Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code2, code3, code4)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code4 [(ngModel)]="code4Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code3, code4, code5)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code5 [(ngModel)]="code5Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code4, code5, code6)" />
                    </mat-form-field>
                    <mat-form-field class="input-code" appearance="outline">
                        <input matInput #code6 [(ngModel)]="code6Value" class="chat-input" maxlength="1"
                            (input)="nextCode(code5, code6, code6)" />
                    </mat-form-field>
                </div>
                <div class="code-area-inner">
                    <button (click)="gotoStep('validateCode')" class="chat-button" mat-flat-button
                        [disabled]="typing">Continue</button>
                    <button (click)="gotoStep('sendAnotherCode')" class="chat-button" mat-flat-button
                        [disabled]="typing">Send the code
                        again</button>
                    <button (click)="gotoStep('startOver')" class="chat-button" mat-flat-button>Start over from the
                        Homepage</button>
                </div>
            </div>

            <div *ngIf="step==='name'" class="response">
                <div class="input-area">
                    <mat-form-field>
                        <mat-label>First Name</mat-label>
                        <input class="input" matInput [(ngModel)]="firstName" class="chat-input" required
                            [errorStateMatcher]="matcher1" (input)="onNameInput()" />
                        <mat-error>Please enter your First Name</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Last Name</mat-label>
                        <input class="input" matInput [(ngModel)]="lastName" class="chat-input" required
                            [errorStateMatcher]="matcher2" (input)="onNameInput()" />
                        <mat-error>Please enter your Last Name</mat-error>
                    </mat-form-field>
                </div>
                <div class="button-area">
                    <button (click)="gotoStep('sponsorToken')" class="chat-button" mat-flat-button>Back</button>
                    <button (click)="gotoStep('address')" class="chat-button" mat-flat-button [disabled]="typing">Next</button>
                </div>
            </div>

            <div *ngIf="step==='address'" class="response">
                <div class="input-area">
                    <mat-form-field>
                        <mat-label>Street</mat-label>
                        <input class="input" matInput [(ngModel)]="address" class="chat-input" required
                            [errorStateMatcher]="matcher1" (input)="onNameInput()" />
                        <mat-error>Please enter your Street</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Apt/Unit#</mat-label>
                        <input class="input" matInput [(ngModel)]="aptunit" class="chat-input" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>City</mat-label>
                        <input class="input" matInput [(ngModel)]="city" class="chat-input" required
                            [errorStateMatcher]="matcher2" (input)="onNameInput()" />
                        <mat-error>Please enter your City</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>State</mat-label>
                        <mat-select matNativeControl [(ngModel)]="state" required [errorStateMatcher]="matcher3" (selectionChange)="onNameInput()">
                            <mat-option value="AL">Alabama</mat-option>
                            <mat-option value="AK">Alaska</mat-option>
                            <mat-option value="AZ">Arizona</mat-option>
                            <mat-option value="AR">Arkansas</mat-option>
                            <mat-option value="CA">California</mat-option>
                            <mat-option value="CO">Colorado</mat-option>
                            <mat-option value="CT">Connecticut</mat-option>
                            <mat-option value="DE">Delaware</mat-option>
                            <mat-option value="DC">District Of Columbia</mat-option>
                            <mat-option value="FL">Florida</mat-option>
                            <mat-option value="GA">Georgia</mat-option>
                            <mat-option value="HI">Hawaii</mat-option>
                            <mat-option value="ID">Idaho</mat-option>
                            <mat-option value="IL">Illinois</mat-option>
                            <mat-option value="IN">Indiana</mat-option>
                            <mat-option value="IA">Iowa</mat-option>
                            <mat-option value="KS">Kansas</mat-option>
                            <mat-option value="KY">Kentucky</mat-option>
                            <mat-option value="LA">Louisiana</mat-option>
                            <mat-option value="ME">Maine</mat-option>
                            <mat-option value="MD">Maryland</mat-option>
                            <mat-option value="MA">Massachusetts</mat-option>
                            <mat-option value="MI">Michigan</mat-option>
                            <mat-option value="MN">Minnesota</mat-option>
                            <mat-option value="MS">Mississippi</mat-option>
                            <mat-option value="MO">Missouri</mat-option>
                            <mat-option value="MT">Montana</mat-option>
                            <mat-option value="NE">Nebraska</mat-option>
                            <mat-option value="NV">Nevada</mat-option>
                            <mat-option value="NH">New Hampshire</mat-option>
                            <mat-option value="NJ">New Jersey</mat-option>
                            <mat-option value="NM">New Mexico</mat-option>
                            <mat-option value="NY">New York</mat-option>
                            <mat-option value="NC">North Carolina</mat-option>
                            <mat-option value="ND">North Dakota</mat-option>
                            <mat-option value="OH">Ohio</mat-option>
                            <mat-option value="OK">Oklahoma</mat-option>
                            <mat-option value="OR">Oregon</mat-option>
                            <mat-option value="PA">Pennsylvania</mat-option>
                            <mat-option value="RI">Rhode Island</mat-option>
                            <mat-option value="SC">South Carolina</mat-option>
                            <mat-option value="SD">South Dakota</mat-option>
                            <mat-option value="TN">Tennessee</mat-option>
                            <mat-option value="TX">Texas</mat-option>
                            <mat-option value="UT">Utah</mat-option>
                            <mat-option value="VT">Vermont</mat-option>
                            <mat-option value="VA">Virginia</mat-option>
                            <mat-option value="WA">Washington</mat-option>
                            <mat-option value="WV">West Virginia</mat-option>
                            <mat-option value="WI">Wisconsin</mat-option>
                            <mat-option value="WY">Wyoming</mat-option>
                        </mat-select>
                        <mat-error>Please select a State</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Zip</mat-label>
                        <input [errorStateMatcher]="matcher4" (input)="onNameInput()" class="input" matInput [(ngModel)]="zip"
                            class="chat-input" maxlength="5" pattern="[0-9]*" inputmode="numeric"
                            (keydown)="preventNonNumeric($event)" required />
                        <mat-error>Please enter your Zip</mat-error>
                    </mat-form-field>
                </div>
                <div class="button-area">
                    <button (click)="gotoStep('name')" class="chat-button" mat-flat-button
                        [disabled]="typing">Back</button>
                    <button (click)="gotoStep('birthdate')" class="chat-button" mat-flat-button
                        [disabled]="typing">Next</button>
                </div>
            </div>

            <div *ngIf="step==='birthdate'" class="response">
                <div class="input-area">
                    <mat-form-field class="input-field">
                        <mat-label>Birthdate</mat-label>
                        <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker" [(ngModel)]="birthdate"
                            (blur)="checkDate()" required [errorStateMatcher]="matcherDate" (input)="onNameInput()" />
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"
                            (blur)="checkDate()"></mat-datepicker-toggle>
                        <mat-datepicker #picker (blur)="checkDate()"></mat-datepicker>
                        <mat-error>Please enter a valid Birthdate</mat-error>
                    </mat-form-field>
                    <div class="date-error" *ngIf="invalidBirthdate">You must be between 30 and 64 to apply for
                        coverage. If you have questions, please contact your broker.</div>

                    <mat-form-field>
                        <mat-label>Gender</mat-label>
                        <mat-select matNativeControl [(ngModel)]="gender" required [errorStateMatcher]="matcher2" (selectionChange)="onNameInput()">
                            <mat-option value="M">Male</mat-option>
                            <mat-option value="F">Female</mat-option>
                        </mat-select>
                        <mat-error>Please select a Gender</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Occupational Specialty</mat-label>
                        <mat-select matNativeControl [(ngModel)]="occupation" required [errorStateMatcher]="matcher3" (selectionChange)="onNameInput()">
                            @for(specialtyCode of specialtyCodes; track specialtyCode){
                            <mat-option value="{{specialtyCode.Code}}">{{specialtyCode.Name}}</mat-option>
                            }
                        </mat-select>
                        <mat-error>Please select an Occupational Specialty</mat-error>
                    </mat-form-field>
                </div>
                <div class="button-area">
                    <button (click)="gotoStep('address')" class="chat-button" mat-flat-button
                        [disabled]="typing">Back</button>
                    <button (click)="gotoStep('earnedIncome')" class="chat-button" *ngIf="!invalidBirthdate"
                        mat-flat-button [disabled]="typing">Next</button>
                    <button (click)="exit()" class="chat-button" *ngIf="invalidBirthdate" mat-flat-button
                        [disabled]="typing">Exit Application</button>
                </div>
            </div>
            <div *ngIf="step==='earnedIncome'" class="response">
                <div class="input-area">
                    <mat-form-field>
                        <mat-label>Earned Income</mat-label>
                        <input
                        matInput
                        [(ngModel)]="earnedIncome"
                        name="earnedIncome"
                        class="input chat-input"
                        required
                        pattern="^\d+$"
                        maxlength="24"
                        [errorStateMatcher]="matcher1"
                        #earnedIncomeModel="ngModel"
                        (keydown)="preventNonNumeric($event)"
                        (input)="onNameInput()"
                        />
                        <mat-error *ngIf="matcher1?.errorOverride">Must be above $30,000</mat-error>
                        <mat-error *ngIf="earnedIncomeModel?.errors?.['required'] && (earnedIncomeModel.dirty)">
                        This field is required
                        </mat-error>
                        <mat-error *ngIf="earnedIncomeModel?.errors?.['pattern'] && (earnedIncomeModel.dirty)">
                        Must be a valid number
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="button-area">
                    <button (click)="gotoStep('birthdate')" class="chat-button" mat-flat-button
                        [disabled]="typing">Back</button>
                    <button (click)="gotoStep('otherInsurance')" class="chat-button" mat-flat-button
                        [disabled]="typing">Next</button>
                </div>
            </div>

            <div *ngIf="step==='otherInsurance'" class="response">
                <div class="input-area">
                    <div class="insurance-table">
                        <div class="table-row" *ngFor="let insurance of otherInsurances">
                            <div class="table-cell">
                                <div class="left">
                                    {{ insurance.Source }}
                                </div>
                            </div>
                            <div class="table-cell">
                                <div class="center">
                                    {{ insurance.MonthlyAmount | currency }}
                                </div>
                            </div>
                            <div class="table-cell">
                                <button mat-icon-button (click)="deleteInsurance(insurance)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="button-area button-area-addCoverage">
                    <button (click)="gotoStep('yesDisabilty')" class="chat-button button-addCoverage" mat-flat-button
                        [disabled]="typing"> {{ hasDisability ? '+ Add Coverage' : '+ Add Coverage' }}</button>
                </div>
                <div class="button-area">
                    <button (click)="gotoStep('earnedIncome')" class="chat-button" mat-flat-button
                        [disabled]="typing">Back</button>
                    <button (click)="gotoStep('emailPhone')" class="chat-button" mat-flat-button
                        [disabled]="typing">{{ hasDisability ? 'Done / Next' : 'No Coverage' }}</button>
                </div>
            </div>
            <div *ngIf="step==='yesDisabilty'" class="response">
                <div class="input-area">
                    <mat-form-field>
                        <mat-label>Insurance Type</mat-label>
                        <mat-select matNativeControl [(ngModel)]="insuranceType" required
                            [errorStateMatcher]="matcher1">
                            <mat-option value="A">Group LTD</mat-option>
                            <mat-option value="B">Association Disability</mat-option>
                            <mat-option value="C">Individual Disability</mat-option>
                            <mat-option value="D">Other</mat-option>
                        </mat-select>
                        <mat-error>Please enter the Insurance Type</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Monthly Amount</mat-label>
                        <input matInput class="input chat-input" [(ngModel)]="monthlyAmount" required
                            [errorStateMatcher]="matcher2"  (keydown)="preventNonNumeric($event)"/>
                        <mat-error>Please enter a valid Monthly Amount</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Insuring Company</mat-label>
                        <mat-select matNativeControl [(ngModel)]="insuringCompany" required
                            [errorStateMatcher]="matcher3">
                            <mat-option value="Aetna">Aetna</mat-option>
                            <mat-option value="Ameritas">Ameritas</mat-option>
                            <mat-option value="Cigna">Cigna</mat-option>
                            <mat-option value="Guardian">Guardian</mat-option>
                            <mat-option value="Hartford">Hartford</mat-option>
                            <mat-option value="MetLife">MetLife</mat-option>
                            <mat-option value="Lincoln Financial">Lincoln Financial</mat-option>
                            <mat-option value="Liberty Mutual">Liberty Mutual</mat-option>
                            <mat-option value="Mutual of Omaha">Mutual of Omaha</mat-option>
                            <mat-option value="MassMutual">MassMutual</mat-option>
                            <mat-option value="Northwestern Mutual">Northwestern Mutual</mat-option>
                            <mat-option value="Prudential">Prudential</mat-option>
                            <mat-option value="Principal">Principal</mat-option>
                            <mat-option value="Reliance Standard">Reliance Standard</mat-option>
                            <mat-option value="Sun Life Financial">Sun Life Financial</mat-option>
                            <mat-option value="The Standard">The Standard</mat-option>
                            <mat-option value="Unum">Unum</mat-option>
                            <mat-option value="Other">Other</mat-option>
                        </mat-select>
                        <mat-error>Please enter the Insuring Company</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Who pays for it?</mat-label>
                        <mat-select matNativeControl [(ngModel)]="whoPays" required [errorStateMatcher]="matcher4">
                            <mat-option value="Self">Self</mat-option>
                            <mat-option value="Employer">Employer</mat-option>
                        </mat-select>
                        <mat-error>Please select who pays for it</mat-error>
                    </mat-form-field>
                </div>
                <div class="button-area">
                    <button (click)="gotoStep('otherInsurance')" class="chat-button" mat-flat-button
                        [disabled]="typing">Back</button>
                    <button (click)="gotoStep('moreDisability')" class="chat-button" mat-flat-button
                        [disabled]="typing || !isOtherInsuranceValid">Save</button>
                </div>
            </div>
            <div *ngIf="step==='moreDisability'" class="response">
                <div class="input-area">
                    <div class="insurance-table">
                        <div class="table-row" *ngFor="let insurance of otherInsurances">
                            <div class="table-cell">
                                <div class="left">
                                    {{ insurance.Source }}
                                </div>
                            </div>
                            <div class="table-cell">
                                <div class="left">
                                    {{ insurance.MonthlyAmount | currency }}
                                </div>
                            </div>
                            <div class="table-cell">
                                <button mat-icon-button (click)="deleteInsurance(insurance)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="button-area button-area-addCoverage">
                    <button (click)="gotoStep('yesDisabilty')" class="chat-button button-addCoverage" mat-flat-button
                        [disabled]="typing"> {{ hasDisability ? '+ Add Coverage' : '+ Add Coverage' }}</button>
                </div>
                <div class="button-area">
                    <button (click)="gotoStep('earnedIncome')" class="chat-button" mat-flat-button
                        [disabled]="typing">Back</button>
                    <button (click)="gotoStep('emailPhone')" class="chat-button" mat-flat-button
                        [disabled]="typing">{{ hasDisability ? 'Done / Next' : 'No Coverage' }}</button>
                </div>
            </div>

            <div *ngIf="step==='emailPhone'" class="response">
                <div class="input-area">
                    <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input class="input" matInput [(ngModel)]="email" class="chat-input" required
                            [errorStateMatcher]="matcherEmail" (input)="onNameInput()" />
                        <mat-icon matSuffix>mail</mat-icon>
                        <mat-error>Please enter a valid Email</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input class="input" matInput [(ngModel)]="phone" class="chat-input" maxlength="14"
                            appPhoneNumberFormatter required [errorStateMatcher]="matcher2" (input)="onNameInput()" />
                        <mat-icon matSuffix>call</mat-icon>
                        <mat-error>Please enter a valid Phone Number</mat-error>
                    </mat-form-field>
                </div>
                <div class="button-area">
                    <button (click)="gotoStep('otherInsurance')" class="chat-button" mat-flat-button 
                        [disabled]="typing">Back</button>
                    <button (click)="gotoStep('quote')" class="chat-button" mat-flat-button
                        [disabled]="typing">See Quote Pricing</button>
                </div>
            </div>
        </div>
    </div>
</div>